// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__0sj6d","show":"snackbar_show__O4X+9","fadein":"snackbar_fadein__WYX8i","fadeout":"snackbar_fadeout__jc4Cu"};